export default __webpack_public_path__ + "static/media/3225179_app_logo_media_popular_social_icon.8e584086.svg";